import classNames from "classnames";
import { SingletonRouter } from "next/router";
import React from "react";

import { getRefsForFlightOffer } from "shared/components/Flights/FlightOffer";
import { getBrandNameForTabLabels } from "shared/lib/brandedFares/formatBrandNameForTab";
import FlightOffer from "shared/types/flightOffer";

import Img from "@components/FileServer/Img";
import MoreBrandsButton from "@components/Flights/BrandedFares/MoreBrandsButton";

interface IBrandTabs {
  flightOffer: FlightOffer;
  selectedStreamParts: string[];
  changeSelectedStreamParts: (
    streamIndex: 0 | 1,
    newKey: string,
    isBrandName: boolean
  ) => void;
  url: SingletonRouter;
  currency: string;
  isCbt: boolean;
  setIsSomeModalOpenned: React.Dispatch<React.SetStateAction<boolean>>;
}

const BrandTabs: React.FC<IBrandTabs> = ({
  flightOffer,
  selectedStreamParts,
  changeSelectedStreamParts,
  setIsSomeModalOpenned,
  url,
  currency,
}) => {
  const showMoreBrands = flightOffer.BrandsDetailsAvailable === "true";

  const showTabIcons = (brandName: string) => {
    const combinationInfo = flightOffer.FlightCombinations.find(
      (combination) => combination.UniformBrandName === brandName
    ).PricingDetail;

    const baggageLimit = combinationInfo.BaggageLimit.Included;
    const baggageSelectionAvailable =
      combinationInfo.BaggageLimit.BaggageSelectionAvailable === "true";

    const baggageIncluded = baggageLimit === "Yes";
    const baggageNotIncluded = baggageLimit === "No";
    const baggageUnknown = baggageLimit === "Unknown";

    const baggageIcon = baggageIncluded
      ? "/static/images/ico-baggage.svg"
      : "/static/images/ico-no-baggage.svg";

    const icons = [];

    if (baggageIncluded) {
      icons.push(
        <Img
          src={baggageIcon}
          className="flight-offer-brand-icon"
          alt="baggage limit icon"
        />
      );
    }

    if (baggageUnknown && baggageSelectionAvailable) {
      return icons.push(
        <Img
          src={baggageIcon}
          className="flight-offer-brand-icon"
          alt="baggage limit icon"
        />
      );
    }

    if (baggageNotIncluded && baggageSelectionAvailable) {
      icons.push(
        <Img
          src={baggageIcon}
          className="flight-offer-brand-icon"
          alt="baggage limit icon"
        />
      );
    }

    if (baggageNotIncluded && !baggageSelectionAvailable) {
      icons.push(
        <Img
          src="/static/images/ico-no-baggage.svg"
          className="flight-offer-brand-icon"
          alt="baggage limit icon"
        />
      );
    }

    return icons.map((icon, index) => ({ ...icon, key: index }));
  };

  return (
    <div className="flight-offer-brands">
      {Object.keys(flightOffer.CurrentCombinations).map((brandName) => {
        const { accessibleName, visibleName } = getBrandNameForTabLabels(
          brandName
        );

        return (
          <div
            role="tab"
            key={brandName}
            data-brandname={brandName}
            aria-label={accessibleName}
            className={classNames("flight-offer-brand", {
              active: brandName === selectedStreamParts[0],
            })}
            onClick={() => changeSelectedStreamParts(0, brandName, true)}
          >
            <div className="flight-offer-brand-nameicon-wrapper">
              <div className="flight-offer-brand-icons">
                {showTabIcons(brandName)}
              </div>
              {visibleName}
            </div>
          </div>
        );
      })}
      {showMoreBrands && (
        <MoreBrandsButton
          flightOffer={flightOffer}
          setIsSomeModalOpenned={setIsSomeModalOpenned}
          getRefsForFlightOffer={() => {
            return getRefsForFlightOffer(flightOffer, selectedStreamParts);
          }}
          url={url}
          currency={currency}
        />
      )}
    </div>
  );
};

export default BrandTabs;
